import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminDeleteBuyerListMutation,
  AdminDeleteBuyerListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminDeleteBuyerListMutation = graphql(`
  mutation adminDeleteBuyerList($id: String!) {
    adminDeleteBuyerList(id: $id)
  }
`);

export function useAdminDeleteBuyerList(
  options?: UseMutationOptions<
    AdminDeleteBuyerListMutation,
    unknown,
    AdminDeleteBuyerListMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(adminDeleteBuyerListMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
  });
  return {
    ...rest,
    mutate: (id: string) => innerMutate({ id }),
  };
}
